import { Button, Spinner } from "react-bootstrap";

const DocumentHeader = ({
  documentName,
  saving,
  saveDraft,
  onSave,
  onSaveDraft,
  onBack,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 0",
          borderBottom: "1px solid #ddd",
        }}
      >
        {/* Left side: Document Name */}
        <h1 style={{ margin: 0 }}>
          <strong>{documentName}</strong>
        </h1>

        {/* Right side: Action Buttons */}
        <div style={{ display: "flex", gap: "10px" }}>
          <Button onClick={onSave} variant="success" disabled={saving}>
            {saving && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
            )}
            Sign
          </Button>
          {/* 
        <Button onClick={onSaveDraft} variant="secondary">
          {saveDraft ? "Saving draft..." : "Save Draft"}
        </Button> */}

          <Button onClick={onBack} variant="light">
            Back
          </Button>
        </div>
      </div>
    </>
  );
};

export default DocumentHeader;
